module.exports = __webpack_public_path__ + "static/img/banner_zpxqy.541378a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PC/banner_zpxqy.png
// module id = AB32
// module chunks = 1